import { PermissionModels } from '@share-models';

export namespace PermissionAccessModels {
  /** Route `data` keys read by `permissionGuard`. */
  export enum RouteDataKey {
    Permissions = 'permissions',
  }

  /** The permissions slice: the user's permissions plus whether they have been fetched yet. */
  export interface State extends PermissionModels.UserPermissionsFeatureState {
    loaded: boolean;
  }
}
